import styled from 'styled-components';

import Button from './Button';

const Buttons = styled.div`
    display: flex;
    justify-content: right;
    align-items: center;
    margin: 1rem 0;
    
    & > ${Button} {
      margin-right: 1em;
    }
    
    & > ${Button}:last-child {
      margin-right: 0;
    }
    
    @media (max-width: 400px) {
      & > ${Button} {
        flex-grow: 1;
      }
    }
`;

export default Buttons;